enum Label {
    NewHomes = 'New homes in ',
    ToRent = 'Properties to rent in ',
    ForSale = 'Properties for sale in ',
    HousePrices = 'Explore house prices in ',
    EstateAgents = 'Find estate agents in ',
    LettingAgents = 'Find letting agents in ',
    CommercialForSale = 'Commercial properties for sale in ',
    CommercialToRent = 'Commercial properties to rent in '
}

enum Urls {
    NewHomes = '/new-homes/property/',
    ToRent = '/to-rent/property/',
    ForSale = '/for-sale/property/',
    HousePrices = '/house-prices/',
    EstateAgents = '/find-agents/estate-agents/',
    LettingAgents = '/find-agents/letting-agents/',
    CommercialForSale = '/for-sale/commercial/property/',
    CommercialToRent = '/to-rent/commercial/property/'
}

type RelatedSearchLinksProps = {
    input?: string;
    type?: string;
    label?: string;
};

export const getRelatedSearchLinks = ({
    input,
    type,
    label
}: RelatedSearchLinksProps) => {
    if (!input || !type || !label) {
        return null;
    }

    switch (type) {
        case 'for-sale':
            return [
                {
                    geo: `${Label.NewHomes}${label}`,
                    uri: `${Urls.NewHomes}${input}/`
                },
                {
                    geo: `${Label.ToRent}${label}`,
                    uri: `${Urls.ToRent}${input}/`
                },
                {
                    geo: `${Label.HousePrices}${label}`,
                    uri: `${Urls.HousePrices}${input}/`
                },
                {
                    geo: `${Label.EstateAgents}${label}`,
                    uri: `${Urls.EstateAgents}${input}/`
                },
                {
                    geo: `${Label.CommercialForSale}${label}`,
                    uri: `${Urls.CommercialForSale}${input}/`
                }
            ];
        case 'to-rent':
            return [
                {
                    geo: `${Label.NewHomes}${label}`,
                    uri: `${Urls.NewHomes}${input}/`
                },
                {
                    geo: `${Label.ForSale}${label}`,
                    uri: `${Urls.ForSale}${input}/`
                },
                {
                    geo: `${Label.HousePrices}${label}`,
                    uri: `${Urls.HousePrices}${input}/`
                },
                {
                    geo: `${Label.LettingAgents}${label}`,
                    uri: `${Urls.LettingAgents}${input}/`
                },
                {
                    geo: `${Label.CommercialToRent}${label}`,
                    uri: `${Urls.CommercialToRent}${input}/`
                }
            ];
        case 'new-homes':
            return [
                {
                    geo: `${Label.ForSale}${label}`,
                    uri: `${Urls.ForSale}${input}/`
                },
                {
                    geo: `${Label.HousePrices}${label}`,
                    uri: `${Urls.HousePrices}${input}/`
                },
                {
                    geo: `${Label.EstateAgents}${label}`,
                    uri: `${Urls.EstateAgents}${input}/`
                },
                {
                    geo: `${Label.CommercialForSale}${label}`,
                    uri: `${Urls.CommercialForSale}${input}/`
                },
                {
                    geo: `${Label.ToRent}${label}`,
                    uri: `${Urls.ToRent}${input}/`
                }
            ];
        default:
            return null;
    }
};
